import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface LoaderDialogData {
  title: string;
  isHtmlContent: boolean;
  isDashboardDesc: boolean;
  content: string;
  closeButton: string;
  actionAlign: string;
  isLoading?: boolean; // Optional for loading state
  loadingMessage?: string; // Optional for loading message
}

@Component({
  selector: 'app-loader-dialog',
  templateUrl: './loader-dialog.component.html',
  styleUrls: ['./loader-dialog.component.css'],
  encapsulation: ViewEncapsulation.None,
})

export class LoaderDialogComponent implements OnInit {
  title = 'Alert';
  isHtmlContent = false;
  isDashboardDesc = false;
  content = '';
  closeButton = 'Close';
  actionAlign = 'end';
  html: SafeHtml | undefined;

  // New properties for loading functionality
  isLoading = false; 
  loadingMessage = 'Please wait...'; // Default loading message

  constructor(
    public dialogRef: MatDialogRef<LoaderDialogComponent>,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: LoaderDialogData
  ) {
    if (data) {
      if (data.title) {
        this.title = data.title;
      }

      if (data.isHtmlContent) {
        this.isHtmlContent = data.isHtmlContent;
        this.html = this.sanitizer.bypassSecurityTrustHtml(data.content);
      }

      if (data.content) {
        this.content = data.content;
      }

      if (data.closeButton) {
        this.closeButton = data.closeButton;
      }

      if (data.actionAlign) {
        this.actionAlign = data.actionAlign;
      }

      if (data.isDashboardDesc) {
        this.isDashboardDesc = data.isDashboardDesc;
      }

      // Set loading state if provided
      if (data.isLoading !== undefined) {
        this.isLoading = data.isLoading;
      }

      // Set loading message if provided
      if (data.loadingMessage) {
        this.loadingMessage = data.loadingMessage;
      }
    }
  }

  ngOnInit(): void {}
}
